import React from 'react'
import { SliderOnboarding } from '@/components/SliderOnboarding'
import { QuestionProps } from '../types'

export const WorkConfidence = (props: QuestionProps) => {
  const { form, disabled } = props

  return <SliderOnboarding {...form.register('confidence_at_work')} disabled={disabled} label='' />
}
